// import { OrderItem } from '@symphony-solo/domain/order/src/lib/models';
import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';

export class CartState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public cart: any;
  public subTotal: number;
  public total: number;
  public cartUnAvailabilItems: any;
  public accountID: number;
  public cartStartTime: string;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.cart = [];
    this.subTotal = 0;
    this.total = 0;
    this.cartUnAvailabilItems = [];
    this.accountID = -1;
    this.cartStartTime = null;
  }
}
